import { createUrlStripper } from "../urlStripper"
import type { VendorParams } from "./UrlParams"

export const parseLanguageLineParams = (url: string): VendorParams => {
  const urlStripper = createUrlStripper(url)
  const participantName = urlStripper.stripParam("participantName")
  const urlWithoutVendorParams = urlStripper.toString()
  return {
    urlWithoutVendorParams,
    participantName,
  }
}
